export default __webpack_public_path__ + "/dist/images/expert-contentimg.e90244044c7a49ec6be095ec466fcf8c.png";